import {useState, useEffect, useCallback} from "react";
import axios from "axios";

function Dashboard(){
    const [deviceId,setDeviceId] = useState("");
    const [data,setData] = useState([]);
    const [loading, setLoading] = useState(false );

    const fetchData = useCallback(async()=>{ //previously fetchData is used inside useEffect,and without useCallback it gets recreated on every render causing dependency issues and unnecessary re renders, so i optimised it for preventing infinite loop
        if(!deviceId) return;
        setLoading(true);

        try{
            const res = await axios.get(
                `https://health-backend-3qyn.onrender.com/api/health-data/${deviceId}`
            );

            setData(res.data );
        } catch(err){
            console.log( err );
        }

        setLoading(false);
    }, [deviceId ]);

    useEffect(()=>{
        const interval = setInterval(()=>{
            fetchData();
        },5000);

        return ()=>clearInterval(interval );
    }, [ fetchData ]);

    return (
        <div style={{ border: "solid #ccc", fontWeight: "bold", fontSize: "20px", margin: "10px", padding: "15px", borderRadius: "8px", background: "#7b7b7b",  }}>
            <input
                style={{ fontWeight: "bold", color: "grey", width: "300px", height: "40px", fontSize: "16px",  }}
                placeholder="Enter deviceId"
                value={deviceId}
                onChange={ ( e ) => setDeviceId( e.target.value )}
            />

            <button onClick={fetchData} style={{ width: "300px", height: "40px", fontSize: "16px", fontWeight: "bold",  }}>
                Fetch all the readings
            </button>

            {loading && <p>loading...</p>}

            <div style={{ backgroundColor: "#3a6079" }}>
                {data.map((i, index) => (
                    <div key={index} style={{ border: "solid #fbefef", margin: "10px", padding: "15px", borderRadius: "8px", background: "#f6f2f2",  }}>
                        <p>@🫀 Heart Rate: { i.heart_rate }</p>
                        <p>@ SpO2: { i.spo2 }</p>
                        <p>@ Time: { i.timestamp }</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Dashboard;